import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, InputAdornment, TextField } from "@mui/material";
import { FixedSizeGrid as Grid } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import wrappedFaCategories from "./faCategories";
import Tabs from "../../Tabs";
import SearchIcon from "@mui/icons-material/Search";
import BlockIcon from "@mui/icons-material/Block";
import CustomAccordion from "../../Accordion";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const SegmentIcon = ({
  selectedIcon,
  onIconSelect,
  title = "Segment Icon",
  showAccordion = true,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(
    Object.keys(wrappedFaCategories)[0]
  );

  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded ? !expanded : false);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const icons = wrappedFaCategories[selectedCategory];

  const filteredIcons = icons.filter((IconComponent) => {
    const name = IconComponent.displayName.toLowerCase();
    const matches = name.includes(searchTerm.toLowerCase());
    return matches;
  });

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
  };

  const handleIconSelect = (IconComponent) => {
    onIconSelect(IconComponent ? <IconComponent /> : "");
  };

  const content = (
    <Box>
      <Tabs
        categories={Object.keys(wrappedFaCategories)}
        selectedCategory={selectedCategory}
        onCategoryChange={handleCategoryChange}
        color={"#81459B"}
        indicatorColor="#C283DA"
      />
      <Box sx={{ padding: "10px 5px" }}>
        <TextField
          label="Search icon"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={handleSearchChange}
          margin="normal"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ backgroundColor: "#F9FAFB" }}
        />
      </Box>
      <Box
        style={{
          height: "200px",
          backgroundColor: "#F9FAFB",
        }}
      >
        <AutoSizer>
          {({ height, width }) => (
            <Grid
              columnCount={9}
              columnWidth={width / 9}
              height={height}
              rowCount={Math.ceil(filteredIcons.length / 8)}
              rowHeight={50}
              width={width}
              style={{
                overflowX: "hidden",
                scrollbarWidth: "none", // For Firefox
                msOverflowStyle: "none",
              }}
            >
              {({ columnIndex, rowIndex, style }) => {
                const index = rowIndex * 9 + columnIndex;
                const IconComponent = filteredIcons[index];
                return (
                  <div style={style} key={index}>
                    {IconComponent && (
                      <IconComponent
                        size={25}
                        style={{
                          display: "block",
                          margin: "auto",
                          cursor: "pointer",
                        }}
                        onClick={() => handleIconSelect(IconComponent)}
                      />
                    )}
                  </div>
                );
              }}
            </Grid>
          )}
        </AutoSizer>
      </Box>
    </Box>
  );

  if (showAccordion) {
    return (
      <CustomAccordion
        title={title}
        icon={selectedIcon || <BlockIcon />}
        expanded={expanded}
        onChange={handleChange}
        secondaryIcon={
          <HighlightOffIcon
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleIconSelect(null);
            }}
          />
        }
      >
        {content}
      </CustomAccordion>
    );
  } else {
    return <Box>{content}</Box>;
  }
};

SegmentIcon.propTypes = {
  selectedIcon: PropTypes.element.isRequired,
  onIconSelect: PropTypes.func.isRequired,
  title: PropTypes.string,
  showAccordion: PropTypes.bool,
};

export default SegmentIcon;
